import React, { useEffect, useState } from "react";
import axios from "axios";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";

const API_UPLOAD =
    "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/persona-item/upload";

const API_GET =
    "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/persona-item/obtiene-persona-item";

const API_DELETE =
    "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/persona-item/borra-persona-item";

const UploadArchivosItem = ({ datos, onUploaded,soloLectura }) => {

    const Usuario = ObtieneDatosCookies()
    const [files, setFiles] = useState([]);
    const [archivosGuardados, setArchivosGuardados] = useState([]);
    const [dragOver, setDragOver] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const persona_id = datos?.persona?.dni;
    const proceso_id = datos?.instancia;
    const item_id = datos?.item?.id;
    // ===============================
    // 🔥 TRAER ARCHIVOS EXISTENTES
    // ===============================
    const fetchArchivos = async () => {
        try {
            const res = await axios.post(API_GET, {
                dni: persona_id,
                item_id: item_id,
            });
//             console.log(res)
            setArchivosGuardados(res.data?.archivos || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (persona_id && item_id) {
            fetchArchivos();
        }
    }, [persona_id, item_id]);

    // ===============================
    // 📥 NUEVOS ARCHIVOS
    // ===============================
    const handleFiles = (selectedFiles) => {
        const nuevos = Array.from(selectedFiles);

        const validos = nuevos.filter((file) =>
            ["application/pdf", "image/jpeg", "image/png"].includes(file.type)
        );

        setFiles((prev) => [...prev, ...validos]);
    };

    const handleChange = (e) => {
        handleFiles(e.target.files);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        handleFiles(e.dataTransfer.files);
    };

    // ===============================
    // ⬆️ SUBIR
    // ===============================
    const handleUpload = async () => {
        if (!files.length) return;

        setLoading(true);
        setMensaje("");

        try {
            const formData = new FormData();

            formData.append("persona_id", persona_id);
            formData.append("proceso_id", proceso_id);
            formData.append("item_id", item_id);

            files.forEach((file) => {
                formData.append("archivos", file);
            });

            await axios.post(API_UPLOAD, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setMensaje("✅ Archivos subidos correctamente");




            setFiles([]);

            fetchArchivos();

        } catch (error) {
            console.error(error);
            setMensaje("❌ Error al subir archivos");
        } finally {
            setLoading(false);
        }
    };

    // ===============================
    // ❌ ELIMINAR
    // ===============================
    const handleDelete = async (archivo_id) => {
//         console.log("que paso")
//         console.log(archivo_id)
        if (!window.confirm("¿Eliminar archivo?")) return;

        try {
            setLoading(true);

            await axios.post(API_DELETE, {
                archivo_id,
                dni: persona_id,
            });

            await fetchArchivos();
        } catch (error) {
            console.error(error);
            alert("Error al eliminar");
        } finally {
            setLoading(false);
        }
    };

    const removeFile = (index) => {
        const nuevos = [...files];
        nuevos.splice(index, 1);
        setFiles(nuevos);
    };

    return (
        <div style={styles.container}>
            <h4>📂 Archivos de: {datos?.persona?.nombre + ", " + datos?.persona?.apellido} </h4>

            {/* ===============================
          📁 ARCHIVOS YA SUBIDOS
      =============================== */}
            {archivosGuardados.length > 0 && (
                <div style={styles.lista}>
                    <h5>Archivos subidos</h5>

                    {archivosGuardados.map((file) => (
                        <div key={file.id} style={styles.fileItem}>
                            <a
                                href={`https://wwwa.isepsantafe.net.ar${file.url}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                📄 {file.nombre}
                            </a>

                            {!file.bloqueado && (
                                <>
                                    {comprueboPermisos(Usuario.funcion, "Borro Archivos Postulante")&&!soloLectura ? (
                                        <button onClick={() => handleDelete(file.id)}>❌</button>
                                    ) : (
                                      <button onClick={() => handleDelete(file.id)}>❌</button>
                                    )}
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* ===============================
          📥 DROP ZONE
      =============================== */}
            {soloLectura?"":<>
                        <div
                style={{
                    ...styles.dropZone,
                    background: dragOver ? "#e3f2fd" : "#fafafa",
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                    setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
                onDrop={handleDrop}
            >
                <p>Arrastrá archivos o hacé click</p>
                <input
                    type="file"
                    multiple
                    onChange={handleChange}
                    style={styles.input}
                />
                            {/* ===============================
          🆕 ARCHIVOS NUEVOS
      =============================== */}
            {files.length > 0 && (
                <div style={styles.lista}>
                    <h5>Archivos a subir</h5>

                    {files.map((file, idx) => (
                        <div key={idx} style={styles.fileItem}>
                            <span>{file.name}</span>
                            <button onClick={() => removeFile(idx)}>❌</button>
                        </div>
                    ))}
                </div>
            )}

            {/* ===============================
          🚀 BOTÓN
      =============================== */}
            <button
                onClick={handleUpload}
                disabled={loading || files.length === 0}
                style={styles.button}
            >
                {loading ? "Subiendo..." : "Subir archivos"}
            </button>

            {mensaje && <p>{mensaje}</p>}
            </div>
            
            </>}



        </div>
    );
};

const styles = {
    container: {
        border: "1px solid #ddd",
        padding: 15,
        borderRadius: 10,
        maxWidth: 600,
    },
    dropZone: {
        border: "2px dashed #aaa",
        padding: 30,
        textAlign: "center",
        borderRadius: 10,
        cursor: "pointer",
        position: "relative",
        marginTop: 10,
    },
    input: {
        position: "absolute",
        width: "100%",
        height: "100%",
        opacity: 0,
        top: 0,
        left: 0,
        cursor: "pointer",
    },
    lista: {
        marginTop: 15,
    },
    fileItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#eee",
        padding: 8,
        borderRadius: 5,
        marginBottom: 5,
    },
    button: {
        marginTop: 15,
        padding: "10px 15px",
        borderRadius: 8,
        border: "none",
        background: "#1976d2",
        color: "#fff",
        cursor: "pointer",
    },
};

export default UploadArchivosItem;